"use client";
import PreFooter from "@/components/common/preFooter";
import { useModalContext } from "@/contexts/ModalContext";

interface PreFooterClientProps {
    title: string;
    description: string;
}

const PreFooterClient = ({ title, description }: PreFooterClientProps) => {
    const modal = useModalContext();

    const handleModalOpen = (modalTitle?: string) => {
        modal.openModal(modalTitle);
    };

    return (
        <PreFooter
            title={title}
            description={description}
            onModalOpen={handleModalOpen}
        />
    );
};

export default PreFooterClient;
